import { useState, useEffect } from "react";
import { trimZeros } from "src/utils/genericFunctions";
import { valueFromRowDataField } from "./NumericInputWithMax";
import { InputWithText } from "./inputWithText";

const InputItem = ({
  itemId,
  rowData,
  editMode,
  id,
  disabled,
  onBlur,
  sxConfig = {},
  disableDecimalDigit = false
}: {
  itemId: string | number;
  rowData: any;
  editMode: boolean;
  id: string;
  onBlur?: (item: string, id: string | number, value: any) => any;
  onChange?: (item: string, id: string | number, value: any) => any;
  disableDecimalDigit?: boolean;
  sxConfig?: any;
  disabled?: boolean;
}) => {
  useEffect(() => {
    // set value on sorting
    setValue(valueFromRowDataField(rowData, id));
  }, [id, rowData]);

  const [value, setValue] = useState(() => valueFromRowDataField(rowData, id));

  /* istanbul ignore next */
  const handleChange = (text: string) => {
    let value = trimZeros(text);
    const [beforeDecimal, afterDecimal] = value.split(".");
    if (disableDecimalDigit) value = beforeDecimal;
    if (afterDecimal?.length > 2) return;
    if (value.includes(".") && beforeDecimal === "") {
      value = "0" + value;
    }

    if (value === "") {
      setValue(0);
      return;
    }
    if (Number(value) >= 0 && Number(value) <= 999999) {
      setValue(value);
    }
  };

  const blurHandler = (receivedValue: string) => {
    if (receivedValue === "") {
      setValue(0);
    }
    onBlur(id, itemId, Number(value));
  };

  return (
    <InputWithText
      editMode={editMode}
      disabled={disabled || rowData?.pricingLoading}
      value={value}
      handleChange={handleChange}
      blurHandler={blurHandler}
      sxConfig={sxConfig}
      rowData={rowData}
      id={id}
    />
  );
};

export default InputItem;
